// extracted by mini-css-extract-plugin
module.exports = {"PreviewScore":"PreviewScore___1gsCQ"};